import { useEffect, useState } from 'react';
import { getCandidateMessages } from '../utils/getCandidateMessages';
import { getCookie } from '../utils/cookies';

export interface WelcomeContentType {
  welcomePageHeading: string;
  welcomePageContent: string;
  isDefault: boolean;
}
export const useWelcomeContent = (): WelcomeContentType => {
  const isBasicFlow = getCookie('BasicFlow') === '1';
  const [welcomeContent, setWelcomeContent] = useState<WelcomeContentType>({
    welcomePageHeading: '',
    welcomePageContent: '',
    isDefault: false,
  });

  const defaultWelcomeContent = {
    welcomePageHeading: isBasicFlow ? `welcome` : `advancedWelcomeHeading`,
    welcomePageContent: isBasicFlow ? `defaultWelcomePageContent` : `advancedWelcomeContent`,
    isDefault: true,
  };

  useEffect(() => {
    (async (): Promise<void> => {
      const responseData = await getCandidateMessages();

      if (
        responseData.code === 200 &&
        (responseData.data?.welcomePageHeading || responseData.data?.welcomePageContent)
      ) {
        setWelcomeContent({
          welcomePageHeading: responseData.data.welcomePageHeading || '',
          welcomePageContent: responseData.data.welcomePageContent || '',
          isDefault: false,
        });
      } else {
        setWelcomeContent(defaultWelcomeContent);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return welcomeContent;
};
